import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EventListSortOptionValues } from 'models/SortByOptions';

import { ViewPanelDropdown } from 'components/_controls/ViewPanelDropdown';

import { sortByDiseaseActivityListByCountry } from 'diseaseActivitiesInCountryLocations/diseaseActivitiesInCountryLocations.slice';
import diseaseActivityListSelectors from 'diseaseActivitiesInCountryLocations/diseaseActivityList.selectors';

import { DiseaseActivityListSearch } from './DiseaseActivityListSearch';

export const DiseaseActivityListToolbar: React.FC = () => {
  const dispatch = useDispatch();
  const sortBy = useSelector(diseaseActivityListSelectors.getDiseaseActivityByCountrySortBy);
  const sortOptions = useSelector(diseaseActivityListSelectors.eventListSortOptions);

  return (
    <>
      <ViewPanelDropdown<EventListSortOptionValues>
        selectedValue={sortBy}
        options={sortOptions}
        onSelect={opt => dispatch(sortByDiseaseActivityListByCountry(opt))}
      />
      <DiseaseActivityListSearch />
    </>
  );
};

export default DiseaseActivityListToolbar;
